const photos = [
	{ src: "/images/home/welder.jpg", alt: "A welder at work with sparks flying" },
	{ src: "/images/home/woodworker.jpg", alt: "A woodworker in a workshop wearing a face shield" },
	{ src: "/images/home/construction.jpg", alt: "A construction worker in a high-visibility jacket" },
];

export default function Environments() {
	return (
		<section className="eo-environments">
			<div className="container">
				<p className="eo-section__overline">Real environments</p>
				<h2 className="eo-section__title">Your hearing protected. All day. Every day.</h2>
			</div>
			<div className="eo-environments__grid">
				{photos.map((p) => (
					<img key={p.src} src={p.src} alt={p.alt} loading="lazy" />
				))}
			</div>
		</section>
	);
}
